export default __webpack_public_path__ + "static/media/pool.1ce210df.png";